module.exports = __webpack_public_path__ + "media/images/empty-board-view-b424ed7c4c12a915fb68799e0c4e1762.svg";